import React, { Component } from 'react';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { PropTypes } from 'prop-types'
import { Modal } from 'react-bootstrap';
import { Form } from 'formsy-react-components';
import { withRouter } from "react-router-dom";
import { Center, ImageSection, LogeButtonSlim, Black, Red, ModalHeading } from '../GeneralStyle'

import ReactGA from "react-ga";

import moment from 'moment'

import headerImage from '../../images/modal/tl_header_login.jpg';

@inject('bookingStore')

@observer
class CancelModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: this.props.showModal,
      cancelSuccess: false,
      isError: false,
      errorMessage: ""
    }

    this.onSubmit = this.onSubmit.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.props.onRef(this)
  }
  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  openModal(data) {
    this.setState({ showModal: true });
  }

  closeModal(data) {
    this.props.bookingStore.rerender()
    this.setState({ showModal: false });
  }

  onSubmit() {
    this.props.bookingStore.cancelBooking(
      this.props.bookingId
    ).then(res => {
      ReactGA.event({
        category: 'Booking',
        action: 'Click Button',
        label: 'Cancel Booking'
      });
      this.setState({
        cancelSuccess: true
      })
    }).catch(err => {
      this.setState({
        isError: true,
        errorMessage: err.message.message
      })
    })
  }

  render() {
    function replaceAll(str, find, replace) {
      return str.replace(new RegExp(find, 'g'), replace);
    }


    let whatsappText = this.props.bookingStore.cancledBooking ? "Ich habe meine Buchung am " + moment(this.props.bookingStore.cancledBooking.bookingDate).locale("de").format('Do MMMM YYYY') + ", mit " + this.props.bookingStore.cancledBooking.slots + " Spielrecht/en, im " + this.props.bookingStore.cancledBooking.golfCourse.courseName + " storniert!" : "Fehlgeschlagen"
    whatsappText = replaceAll(whatsappText, " ", "%20")

    // const shareButon = (
    //   <div>
    //     <Center marginTop={30} marginBottom={30}>
    //       <Black>Sie können hier Ihre Stornierung sofort in Whatsapp bekanntgeben!</Black>
    //     </Center>
    //     <Center marginTop={30} marginBottom={30}>
    //       <a href={"whatsapp://send?text=" + whatsappText}>
    //         <LogeButtonSlim
    //           onClick={() => this.closeModal}
    //           hoverFontColor={"white"}>
    //           in Whatsapp teilen
    //           </LogeButtonSlim>
    //       </a>
    //     </Center>
    //   </div>
    // )

    const successMessage = (
      <div>
        <Center marginTop={30} marginBottom={30}>
          <Black>Buchung erfolgreich storniert!</Black>
        </Center>
        <Center marginTop={30} marginBottom={30}>
          <LogeButtonSlim
            onClick={() => this.closeModal()}
            hoverFontColor={"white"}>
            schließen
          </LogeButtonSlim>
        </Center>
      </div>
    )

    const sureCancelButton = (
      <div>
        <Center marginTop={30}>
          <Black>Wollen sie Ihre Buchung im {this.props.courseName}, am {moment(this.props.bookingDate).locale("de").format('Do MMMM YYYY')} wirklich stornieren?</Black>
        </Center>
        <Form
          onSubmit={this.onSubmit}
          layout={'vertical'}
          validateOnSubmit={false}
          validatePristine={false}
          formNoValidate
          noValidate
        >
          <Center marginTop={30} marginBottom={30}>
            <LogeButtonSlim
              hoverFontColor={"white"}>
              Bestätigen
              </LogeButtonSlim>
          </Center>
        </Form>
      </div>
    )

    const errorButton = (
      <div>
        <Center marginTop={30}>
          <Red>{this.state.errorMessage}</Red>
        </Center>
        <Form
          onSubmit={this.closeModal}
          layout={'vertical'}
          validateOnSubmit={false}
          validatePristine={false}
          formNoValidate
          noValidate
        >
          <Center marginTop={30} marginBottom={30}>
            <LogeButtonSlim
              onClick={() => this.closeModal}
              hoverFontColor={"white"}>
              Abbrechen
              </LogeButtonSlim>
          </Center>
        </Form>
      </div>
    )
    return (
      <Modal show={this.state.showModal} onHide={this.closeModal}>
        <ImageSection background={headerImage}>
          <Modal.Header closeButton>
            <Modal.Title>
              <div>
                <ModalHeading>
                  Buchung stornieren
                </ModalHeading>
              </div>
            </Modal.Title>
          </Modal.Header>
        </ImageSection>
        <Modal.Body>
          {this.state.cancelSuccess
            ? successMessage
            : this.state.isError ? errorButton : sureCancelButton
          }

        </Modal.Body>
      </Modal>
    );
  }
}

CancelModal.propTypes = {
  bookingStore: MobxPropTypes.observableObject,
  bookingId: PropTypes.string,
  courseName: PropTypes.string,
  bookingDate: PropTypes.string,
};

export default withRouter(CancelModal);



// WEBPACK FOOTER //
// /src/components/internal/CancelModal.js